@let isOverlayOpen = panelOpened | async;

<div
	cdkOverlayOrigin
	#origin="cdkOverlayOrigin"
	(mousedown)="!disabledDropdown && $event.preventDefault()"
	(click)="!disabledDropdown && openOverlay()"
>
	<mat-form-field
		appearance="outline"
		class="mb-2 w-full {{classList}}"
		[class.has-chips]="chips.length > 0"
		[class.is-overlay-open]="isOverlayOpen"
		[ngClass]="{'topics-chips-selector-disabled': disabledDropdown}"
	>
	  <mat-label>{{label}}</mat-label>
	  <mat-chip-grid tabIndex="-1" #chipGrid class="chips-selector-chip-grid" [ngStyle]="{'max-height.px': maxHeightPx}">
		  <mat-chip-row *ngFor="let chip of chips" tabIndex="-1" (removed)="removeItem(chip.key)">
			<span class="mat-chip-max-width si-ui-chip__label" [matTooltip]="chip.value?.[bindLabel] || chip.value">{{chip.value?.[bindLabel] || chip.value}}</span>
			<button tabIndex="-1" matChipRemove>
			  <fa-icon class="si-icon" [icon]="['fal', 'circle-xmark']"></fa-icon>
			</button>
		  </mat-chip-row>

		  <input
			#searchInput
			matInput
			[placeholder]="!chips.length ? placeholder : ''"
			[formControl]="filterControl"
			[matChipInputFor]="chipGrid"
			(matChipInputTokenEnd)="onMatChipInputTokenEnd($event)"
		  />
	  </mat-chip-grid>

	  <div matSuffix class="flex items-center gap-4">
		@if (isLoading) {
		  <mat-progress-spinner [mode]="'indeterminate'" [diameter]="16"></mat-progress-spinner>
		}

		@if (!filterControl.value || filterControl.value?.trim().length === 0) {
		  <fa-icon
			aria-hidden="true"
			class="si-icon si-select-arrow cursor-pointer"
			[class.si-select-arrow--open]="isOverlayOpen"
			[icon]="['fal', 'chevron-down']"
			(click)="onChevronClick($event)"
		  ></fa-icon>
		}

		@if (filterControl.value?.trim().length > 0 && !isLoading) {
		  <fa-icon
			class="si-icon backspace-icon cursor-pointer py-0"
			[matTooltip]="'Clear Search'"
			aria-hidden="true"
			[icon]="['fal', 'delete-left']"
			(mousedown)="$event.preventDefault()"
			(click)="$event.stopPropagation(); onClose()"
		  ></fa-icon>
		}

		@if (showClear && chips.length && !disabledChips) {
		  <button
			matIconButton
			class="mat-primary si-icon-button-sm chips-selector-clear-button"
			(mousedown)="$event.preventDefault()"
			(click)="$event.stopPropagation(); clearAll()"
		  >
			<fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
		  </button>
		}
	  </div>
	</mat-form-field>
</div>

<ng-template
	cdk-connected-overlay
	[cdkConnectedOverlayOrigin]="origin"
	[cdkConnectedOverlayOpen]="isOverlayOpen"
	[cdkConnectedOverlayMinWidth]="origin.elementRef.nativeElement.offsetWidth"
	[cdkConnectedOverlayHasBackdrop]="false"
	[cdkConnectedOverlayOffsetY]="-8"
	(detach)="closeOverlay()"
	(overlayOutsideClick)="onOverlayOutsideClick($event)"
>
	<div class="overlay-panel" [@.disabled]="true">
		@let  filteredItems = filteredItems$ | async;

		@if (filteredItems) {
			<cdk-virtual-scroll-viewport
				[itemSize]="itemsSize"
				[minBufferPx]="itemsSize * 10"
				[maxBufferPx]="itemsSize * 10"
				[style.height]="'240px'"
				[style.max-height]="itemsSize * (filteredItems?.length > 5 ? 5 : filteredItems?.length) + ((filteredItems | isSelectAllShow: filterControl?.value : selectAllConfig: chips.length) ? itemsSize : 0) + (!filterControl?.value && preOptionTemplate ? itemsSize : 0) + 'px'"
				class="chips-selector-form-field-cdk-virtual-scroll-viewport"
				(scrolledIndexChange)="onVirtualScroll()"
			>
				@if (!filterControl?.value && preOptionTemplate) {
					<mat-option  [disabled]="disabledChips"  (click)="$event.stopPropagation()">
						<div class="mat-option-custom-wrapper info-text">
							<ng-container *ngTemplateOutlet="preOptionTemplate"></ng-container>
						</div>
					</mat-option>
				}

				@if (filteredItems | isSelectAllShow: filterControl?.value : selectAllConfig : chips.length) {
					<mat-option [disabled]="disabledChips" (onSelectionChange)="!disabledChips && onSelectAll(filteredItems)">
						<div class="mat-option-custom-wrapper" >Select All</div>
					</mat-option>
				}

				<mat-option
					*cdkVirtualFor="let item of filteredItems"
					[value]="bindValue ? item[bindValue] : item"
					[ngClass]="item | chipsSelectorOptionClasses : angularIcon : isMessageOption(item)"
					[disabled]="disabledChips || isMessageOption(item)"
					(onSelectionChange)="!disabledChips && onSelectOption($event, item)"
				>
					<div class="mat-option-custom-wrapper">

						@if (angularIcon?.values?.includes(item)) {
							@if (angularIconIconProp) {
								<fa-icon class="si-icon list-marker" aria-hidden="true" [icon]="angularIconIconProp"></fa-icon>
							}
						}

						<span class="truncate" [tooltipIfTruncated]="listElementTooltipIfTruncated ? (bindLabel ? item[bindLabel] : item) : ''">{{bindLabel ? item[bindLabel] : item}}</span>
					</div>
				</mat-option>
			</cdk-virtual-scroll-viewport>
		}
	</div>
</ng-template>
